/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import { ICreateSceneTag, ISceneTag } from '../interfaces/scene-tag';

export class SceneTagService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getSceneTagById(id: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING.GET_SCENE_TAGS,
					null,
					{ reqPathParam: id },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addSceneTag(newSceneTagData: ISceneTag) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.CREATE_SCENE_TAG,
					this.formatSceneTagReqData(newSceneTagData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateSceneTag(sceneTagToUpdateData: ISceneTag) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.UPDATE_SCENE_TAG,
					this.formatSceneTagReqData(sceneTagToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getSceneTags(page: number, { searchKey = '' }: { searchKey: string }) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING.GET_SCENE_TAGS,
					{},
					{
						pathParams: { page: page || 1, searchKey },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}

	searchSceneTagsAutoComplete({ searchKey }: { searchKey: string }) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.SEARCH_SCENE_TAGS,
					{},
					{
						pathParams: {
							searchKey,
						},
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	deleteSceneTag(id: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().SCENE_MATCHING.DELETE_SCENE_TAG,
			null,
			{ reqPathParam: id },
		);
	}

	private formatSceneTagReqData({
		id,
		name,
		audio,
	}: ISceneTag): ICreateSceneTag {
		return {
			...(id ? { id } : {}),
			name,
			audioId: audio.id,
		};
	}
}
